import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

/**
 * COMPASS-1197 (HSY req 206) — the load's routed detail. `:id` is the
 * identity pair "{year}-{number}" (Annex 1.1 §6.2), not a relay id: the
 * platform has no root `node` query and the pair is what HSY quotes anyway.
 * Two tabs — Containers: which container was emptied into the load, and
 * when; History (COMPASS-1196, req 202): the load's traceable change
 * history. (The stack's Weights tab needs the req-200 backend and is not
 * part of these tickets.)
 */
export const createTruckloadsRouteMap = (prefix: string) => ({
  '/:id': (id = ':id') =>
    pathJoin(prefix)(id).chainMapAuto(
      (prefix2: string) => ({
        containers: pathJoin(prefix2)('containers').chain,
        history: pathJoin(prefix2)('history').chain,
      }),
      {
        title: <T _str="Load details" />,
        breadCrumbTitle: <T _str="Load" />,
      }
    ),
})
